import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    color: 'white',
    position: 'relative',
    backgroundColor: '#1F1F1F',
    border: '1px solid',
    borderColor: '#E0E3E7',
    fontSize: 16,
    
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: 'blue',
    },
    '&:disabled': {
      backgroundColor: '#E0E3E7'
    },
  },
}));

const CustomTextField = (props) => {
  return (
    <CustomInput 
      {...props}
      id="bootstrap-input"
    />
  );
};

export default CustomTextField;